<template>
	<div class="App font font--sans font--sizeDefault" lang="de">

		<AppSidebar class="App__sidebar"></AppSidebar>

		<MhRouterViewWrapper class="App__body hSpace hSpace--appBody"></MhRouterViewWrapper>

		<MhModal class="color color--primary" :show="showImprintModal" @close="showImprintModal = false">
			<template slot="header">
				<div class="font font--bold font--sizeLarge">
					Impressum<br/>
					<br/>
				</div>
			</template>
			<template slot="closeButton">
				<a class="circleIcon color color--primary" role="button">
					<BaseIcon type="cross"></BaseIcon>
				</a>
			</template>
			<template slot="body">
				<div class="richText">
					<strong>Anbieter</strong><br />
					<br />
					Landesamt für Denkmalpflege<br />
					Berliner Straße 12<br />
					73728 Esslingen (Neckar)<br />
					Mail: <a href="mailto:Henrik.Junius@rps.bwl.de">Henrik.Junius@rps.bwl.de</a> <br />
					<br />
					Beachten Sie bitte, dass Ihre Mitteilung an uns über eine E-Mail nicht verschlüsselt wird. Ohne Verschlüsselung ist die Kenntnisnahme durch Dritte nicht ausgeschlossen. Soweit wir Ihrer Mitteilung entnehmen können, dass Sie eine Antwort wünschen, gehen wir davon aus, dass Sie mit einer Beantwortung durch eine unverschlüsselte E-Mail einverstanden sind, wenn unsere Antwort auch nach ihrem Inhalt keiner Verschlüsselung bedarf.<br />
					<br />

					<strong>Hinweise zur Nutzung:</strong><br />
					<br />
					<ol>
						<li>
							Das Nutzungsrecht wird Ihnen unentgeltlich eingeräumt.
						</li>
						<li>
							Das Landesamt für Denkmalpflege Baden-Württemberg im Regierungspräsidium Stuttgart übernimmt
							keine Haftung für Hard- oder Softwareschäden, die durch die Anwendung dieser Anwendung verursacht werden.
						</li>
						<li>Es wird keinerlei Support für die Software gewährleistet. Das LAD und CSGIS haften nicht für Fahrlässigkeit.
							Eine Haftung für mittelbare Schäden oder die Wiederbeschaffung von Daten wird ausgeschlossen.
						</li>
					</ol>
					<br />

					<strong>Projektteam</strong><br />
					<br />
					Marco Schrickel<br />
					Mario Helbing<br />
					Toni Schönbuchner<br />
					<br />
					<strong>Projektumsetzung</strong><br />
					<br />
					CSGIS GbR<br />
					Am Eichbüchl 7<br />
					D - 82223 Eichenau<br />
					<a href="https://www.csgis.de/">www.csgis.de</a><br />
					<br />
				</div>
			</template>
			<template slot="footer"></template>
		</MhModal>

		<!--
		-->
		<MhDelegateLinks></MhDelegateLinks>
		<MhDevInfos :showOnHosts="['localhost', 'wp-kickstart-vue:8080']"></MhDevInfos>

	</div>
</template>

<script>
	// @ is an alias to /src
	import { EventBus } from '@/event-bus.js'
	import resize from 'vue-resize-directive'
	import RestHandler from '@/components/RestHandler/RestHandler.js'

	import MhDevInfos from './components/MhDevInfos/MhDevInfos.vue'
	import MhDelegateLinks from './components/MhDelegateLinks/v5/MhDelegateLinks.vue'
	import MhRouterViewWrapper from './components/MhRouterView/v2/MhRouterViewWrapper.vue'
	import MhModal from './components/MhModal/v2/MhModal.vue'
	import AppSidebar from './components/CSGIS/AppSidebar.vue'
	import BaseIcon from './components/CSGIS/BaseIcon.vue'

	import Doc from './classes/v2/Doc.class.js'
	import docConfig from './config/doc.config.js'

	export default {
		name: 'App',
		components: {
			MhRouterViewWrapper,
			MhDevInfos,
			MhDelegateLinks,
			MhModal,
			BaseIcon,
			AppSidebar,
		},
		directives: {
			resize,
		},
		mixins: [ RestHandler ],
		data() {
			return {
				doc : {},
				showImprintModal : false,
				trashFilenames : [
					"katze.jpg",
					"hund.jpg",
					"dummy-840x1360-laptop-mit-einem-richtig-langen-titel-jawohl-und-gleich-noch-viel-viel-länger.jpg",
					"dummy-840x1360-cat.jpg",
					"dummy-840x1360-frostedwindow.jpg",
					"dummy-840x1360-gambiagirl.jpg",
					"dummy-840x1360-motocross.jpg",
					"dummy-840x1360-spicery.jpg",
					"dummy-840x1360-window.jpg",
					"dummy-926x1500-bull.jpg",
					"dummy-926x1500-cottage.jpg",
					"dummy-926x1500-glasscement.jpg",
					"dummy-926x1500-rosa.jpg",
					"dummy-926x1500-skijumping.jpg",
					"dummy-926x1500-snake.jpg",
					"dummy-926x1500-spuma.jpg",
					"dummy-1000x1000-azukibeans.jpg",
					"dummy-1000x1000-bankcard.jpg",
					"dummy-1000x1000-basketball.jpg",
					"dummy-1000x1000-butterfly.jpg",
					"dummy-1000x1000-roof.jpg",
					"dummy-1000x1000-trafficsign.jpg",
					"dummy-1000x1000-tshirt.jpg",
					"dummy-1080x1920-ballet.jpg",
					"dummy-1080x1920-berlinhouses.jpg",
					"dummy-1080x1920-dragonfly.jpg",
					"dummy-1080x1920-eggs.jpg",
					"dummy-1080x1920-headphone.jpg",
					"dummy-1080x1920-northkorea.jpg",
					"dummy-1080x1920-parkbench.jpg",
					"dummy-1360x840-centurion.jpg",
					"dummy-1360x840-lightsignal.jpg",
					"dummy-1360x840-lizard.jpg",
					"dummy-1360x840-stairs.jpg",
					"dummy-1360x840-tabletennis.jpg",
					"dummy-1360x840-wallstreet.jpg",
					"dummy-1360x840-wine.jpg",
					"dummy-1600x900-archconversation.jpg",
					"dummy-1600x900-barbarastanwyck.jpg",
					"dummy-1600x900-chocolate.jpg",
					"dummy-1600x900-dollar.jpg",
					"dummy-1600x900-flamingo.jpg",
					"dummy-1600x900-goggles.jpg",
					"dummy-1600x900-icicle.jpg",
					"dummy-1760x990-alpinist.jpg",
					"dummy-1760x990-canislupus.jpg",
					"dummy-1760x990-entrance.jpg",
					"dummy-1760x990-golfballs.jpg",
					"dummy-1760x990-lecker.jpg",
					"dummy-1760x990-quickshop.jpg",
					"dummy-1760x990-shandilee.jpg",
					"dummy-2040x1360-auger2.jpg",
					"dummy-2040x1360-chip.jpg",
					"dummy-2040x1360-city.jpg",
					"dummy-2040x1360-frozenraspberry.jpg",
					"dummy-2040x1360-handball.jpg",
					"dummy-2040x1360-icecrystal.jpg",
					"dummy-2040x1360-wardrobe.jpg",
					"dummy-2090x1290-apollo11.jpg",
					"dummy-2090x1290-cherry.jpg",
					"dummy-2090x1290-cow.jpg",
					"dummy-2090x1290-habitation.jpg",
					"dummy-2090x1290-highjump.jpg",
					"dummy-2090x1290-hip.jpg",
					"dummy-2090x1290-stockexchange.jpg",
					"dummy-2160x2880-bag.jpg",
					"dummy-2160x2880-glasshouse.jpg",
					"dummy-2160x2880-horserace.jpg",
					"dummy-2160x2880-mermaid.jpg",
					"dummy-2160x2880-sheep.jpg"
				],
			}
		},
		computed: {},
		methods: {
			getLinkWithoutHostname( url ){
				let theReturn = ''

				try {
					let _url = new URL( url )
					theReturn = _url.pathname
				}
				catch(e) {
					//
				}

				return theReturn
			},
		},
		mounted(){
			this.doc = new Doc( docConfig )

			// fill with dummy data
			const dummyFilenames = this._.slice( this.trashFilenames, 0, 0 )
			// wait til all thesauri are loaded
			setTimeout(()=>{
				dummyFilenames.forEach((o)=>{
					this.doc.addDataRow({
						dateiname : o,
						datierung : 'vorgeschichtlich unbestimmt:Erdgeschichte',
					})
				})
			}, 1000)

			/*
			*/

			this.isReady = true

			//console.log( this.doc.dataRows )
		}
	}
</script>

<style lang="less">
	@import (reference) "less/vars.less";
	@import (reference) "less/mixins.less";
	@import "less/atoms.less";

	html {
		.font;
		.font--sans;
		.font--sizeDefault;

		background-color: @swatches[appBg];
		color: @swatches[textBlack];
	}
	strong, b {
		.font--bold;
	}
	button {
		cursor: pointer;
	}
	h1, h2, h3, h4, h5 {
		font-size: inherit;
		line-height: inherit;
		font-weight: inherit;
		margin: 0;
	}
	a {
		cursor: pointer;
		color: inherit;
		text-decoration: none;

		&.link {
			transition: all 0.1s ease;
			opacity: 0.75;

			&:hover { opacity: 1; }
		}
	}
	pre {
		@color: black;

		position: relative;
		padding: 0.5em;
		width: 100%;
		min-height: 2em;

		//margin-bottom: 0.5em;
		//&:first-of-type { margin-top: 1em; }
		//&:last-of-type { margin-bottom: 0em; }
		& + & { margin-top: 1em; }

		//color: fade(@color, 65);
		tab-size: 4;
		white-space: pre;

		outline: 1px solid fade(@color, 25);
		background-color: fade(@color, 5);
		overflow: auto;
		//display: none;

		// label
		&[name]:after {
			position: absolute;
			top: 0; right: 0;
			background-color: fade(@color, 15);
			font-size: 13px;
			line-height: 1em;
			font-family: sans-serif;
			color: fade(@color, 75);
			padding: 0.25em 0.5em;
			content: attr(name);
			font-family: inherit;
		}
	}
	hr {
		border: none;
		border-top: 1px solid;
		margin: 0.5em 0;
		opacity: 0.25;
	}
	ul, ol {
		margin-left: 1rem;
	}

	.view {
		margin: 0 auto;
		&__inner {
			//background-color: fade( white, 90 );
			//padding: 1rem;
		}
	}
	.hSpace--app {
		padding-left: 1rem;
		padding-right: 1rem;
	}
	.hSpace--formRow {
		padding-left: 1rem;
		padding-right: 1rem;
	}
	.hSpace--appBody {
		padding-left: 2rem;
		padding-right: 2rem;
	}
	.maxWidth--appBody {
		max-width: 950px;
	}
	.contentModule {
		position: relative;

		[showBorders2] & {
			.label( attr(name), red );
			outline: 1px solid red;
			background-color: fade( red, 10 );
		}

		//&__inner { padding: 1em; }
	}
	.circleIcon {
		position: relative;
		height: 30px; width: 30px;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		border-radius: 50%;
		cursor: pointer;
		transition: all 0.2s ease;

		&::before { // border
			position: absolute;
			top: 0; left: 0; right: 0; bottom: 0;
			border-radius: inherit;
			border: 1px solid currentColor;
			content: "";
			opacity: 0.5;
			transition: inherit;
		}
		&::after { // background
			position: absolute;
			top: 0; left: 0; right: 0; bottom: 0;
			border-radius: inherit;
			background-color: currentColor;
			content: "";
			opacity: 0.05;
			transition: inherit;
		}
		&:active {
			transform: translateY(2px);
		}

		.BaseIcon {
			opacity: 0.75;
			transition: inherit;
		}

		&:hover {
			&::before, .BaseIcon { opacity: 1; }
			&::after { opacity: 0.1; }
		}

		&--isDisabled {
			pointer-events: none;
			&::before { border-style: dashed; opacity: 0.35; }
			.BaseIcon { opacity: 0.35; }
		}
	}
	.richText {
		a {
			transition: all 0.1s ease;
			opacity: 0.65;
		}
		a:hover {
			opacity: 1;
			text-decoration: underline;
		}
	}

	.App { // vars
		--sidebar-width : @app[sidebarWidth];
	}
	.App { // layout
		min-height: 100vh;

		&__body {
			width: calc( 100vw - var(--sidebar-width));
			margin-left: var(--sidebar-width);
		}
		&__sidebar {
			position: fixed;
			top: 0; left: 0; bottom : 0;
			width: var(--sidebar-width);
			z-index: 10;
		}
	}

	.App .BaseButton,
	.App .BaseFileInput {
		--fontWeight : 500;

		--borderColor : @swatches[primary];

		--filled-bgColor   : @swatches[primary];
		--filled-textColor : white;

		--outlined-bgColor   : @swatches[primaryLighter];
		--outlined-textColor : @swatches[primary];

		--hover-color			: @swatches[primaryDarker];
		//--hover-color			: red;
		--hover-outlined-bgColor : @swatches[primaryLight];
		--active-outlined-bgColor: @swatches[primaryLight];
	}

	@media @mediaQueries[xs] {}
	@media @mediaQueries[sm] {}
	@media @mediaQueries[md] {}
	@media @mediaQueries[dt] {}
	@media @mediaQueries[lg] {}
	@media @mediaQueries[xl] {}
</style>
